/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Phone = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M17.4 2.8L14.2 2c-.4-.1-.7.1-.9.4L11.8 6c-.1.3 0 .7.2.9l1.9 1.5c-1.1 2.4-3.1 4.4-5.5 5.5L6.8 12c-.2-.3-.6-.3-.9-.2l-3.5 1.5c-.3.1-.5.5-.4.9l.7 3.2c.1.4.4.6.8.6 8 0 14.5-6.5 14.5-14.5 0-.3-.2-.7-.6-.7z" />
  </svg>
);

export default extendIcon(Phone);
